const css = `._4zJXmG__row{flex-direction:row}._4zJXmG__row-reverse{flex-direction:row-reverse}._4zJXmG__column{flex-direction:column}._4zJXmG__column-reverse{flex-direction:column-reverse}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"row":"_4zJXmG__row","column":"_4zJXmG__column","column-reverse":"_4zJXmG__column-reverse","row-reverse":"_4zJXmG__row-reverse"};
